import React, {Component} from 'react';
import { Input, Grid, Radio, Label, Icon } from 'semantic-ui-react';
import { Commons } from 'components';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import DatePicker from 'react-datepicker';

class StaffStop extends Component {
  state = {
    stopType: 'im',
    sDate: null
  }
  onClickEvent = async (type, data) => {
    switch (type) {
      case 'radio':
        await this.setState({ stopType: data })
        break;
      case 'sDate':
        await this.setState({ sDate: data });
        break;
      default:
        break;
    }
    const { changeStopParm } = this.props;
    const { stopType, sDate } = this.state;
    const params = {
      stopType,
      sDate
    }
    changeStopParm(params);
  }

  render() {
    const { stopType, modalType } = this.props;
    const { sDate } = this.state;
    const styles = {
      text: { color: "red" }
    }
    return (
      <Grid className="content">
        <Grid.Row style={{ paddingBottom: 0, height: 35 }}>
          <Grid.Column width={1} />
          <Grid.Column width={15}>
            <span style={{ cursor: 'pointer'}} onClick={(e) => this.onClickEvent('radio', 'im')}>
              <Radio
                style={{ marginRight: 5 }}
                checked={stopType === 'im'}
              />
              <span>
                {
                  modalType === 'stop' ? '즉시 일시정지' : '즉시 탈퇴'
                }
              </span>
            </span>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={1} />
          <Grid.Column width={15}>
            <span style={{ cursor: 'pointer' }} onClick={(e) => this.onClickEvent('radio', 're')}>
              <Radio
                style={{ marginRight: 5 }}
                checked={ stopType === 're' }
              />
              <span>
                {
                  modalType === 'stop' ? '일시정지 예약' : '탈퇴 예약'
                }
              </span>
            </span>
            <Input
              labelPosition='left' type='text'
              style={{
                verticalAlign: 'bottom',
                marginLeft: 20,
                marginRight: 10,
              }}
            >
              <Label basic>
                <Icon disabled style={{ lineHeight: 2 }} name='calendar' />
              </Label>
              <DatePicker
                className="startDate"
                customInput={<input style={{ width: 152, height: 32 }} />}
                selected={sDate}
                minDate={moment()}
                onChange={(e) => this.onClickEvent('sDate', e)}
                dateFormat="YYYY-MM-DD"
                placeholderText="YYYY-MM-DD"
                disabled={stopType === 'im'}
              />
            </Input>
            <Commons.Time
              timeType="sTime"
              defVal={'not default value'}
              placeholder={'HH'}
              isShowMinute={false}
              isShowSecond={false}
              cName={'sf-modal'}
              isDim={stopType === 'im'}
          />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={1} />
          <Grid.Column width={15}>
            {
              modalType === 'stop'
              ? (
                <div>
                  <span>
                    * 일시정지 기간동안 식권대장 <span style={styles.text}>사용이 중지</span>됩니다.
                  </span><br></br>
                  <span>
                    * 일시정지 예약 취소는 '정보 변경내역'에서 예약시간 전까지 할 수있습니다.
                  </span><br></br>
                  <span>
                    * 사용자에게 자동으로 설정된 식대는 지급되지만, 직접 식대 지급 / 차감은 할 수 없습니다.
                  </span><br></br>
                </div>
              ) : (
                <div className="content">
                  <span>* 퇴사처리 후 식대
                    <span style={styles.text}> 지급 및 사용이 즉시 중지 </span>
                    됩니다.
                  </span><br></br>
                  <span>* My포인트 환불에 대해선
                    <span style={styles.text}> 식권대장에 문의</span>
                    해주셔야 합니다.
                  </span><br></br>
                  <span> * 계정 탈퇴 후
                    <span style={styles.text}> 복구가 불가능</span>
                    하오니, 신중히 처리해주시길 바랍니다.
                  </span>
                </div>
              )
            }

          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default StaffStop;
